module.exports = __webpack_public_path__ + "static/media/item_39_1.b49eb397.png";